export const imgxUrl = 'https://assets-imgx.fubo.tv/marketing/lp/images/'
export const videoUrl = 'https://assets.fubo.tv/marketing/lp/videos/'
export const videoUrlNew = 'https://assets-videos.fubo.tv/marketing/lp/'

export const devicePosters = {
  nhl: 'https://assets-imgx.fubo.tv/marketing/lp/images/devices/nhl-device-2.png',
}

export { ratePlanCodes } from './ratePlanCode'
export { promoCodes } from './promoCodes'
export { videos } from './videos'
export { networkLogos } from './networkLogos'
export { leagueLogos } from './leagueLogos'
export { championshipLogos } from './championshipLogos'
export { networkSets } from './networkSets'
export { caPlanPricing } from './planData/canadaPlanData'
export { addOnCodes } from './addOnCodes'
export { sportIds, leagueIds, teamIds } from './personalizationIds'
export { PlanTypes } from './standaloneData'
